export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13757.9f35d6ec.jpg";